import { Button, Form, Input, Table, Tooltip } from "antd";
import { useContext, useEffect, useState } from "react";
import {
  RiFileExcel2Line,
  RiDeleteBinLine,
  RiFilterOffLine,
} from "react-icons/ri";
import { AiOutlineSafetyCertificate } from "react-icons/ai";
import { SlReload } from "react-icons/sl";

import { LuUpload, LuPlus, LuShieldClose } from "react-icons/lu";

import { FiEdit } from "react-icons/fi";
import { ExportToExcel } from "../../../utils/exportExcel";

import CreateUser from "./components/CreateUser";
import UpdateUser from "./components/UpdateUser";
import { useQuery } from "@tanstack/react-query";
import Something from "../../../components/shared/Something";
import {
  handleExportCustomers,
  handleFetchCustomers,
} from "../../../api/customers";
import AllBusinesses from "./components/AllBusinesses";
import { useLocation, useNavigate } from "react-router";
import UploadCustomers from "../businesses/components/UploadCustomers";
import formatShort from "../../../utils/formatShort";
import { AuthContext } from "../../../contexts/AuthContext";
import CreditMetrics from "./components/CreditMetrics";
import formatAccount from "../../../utils/formatAccount";
import UpdateExternal from "./components/UpdateExternal";
const { Search } = Input;
export default function Customers() {
  const { auth } = useContext(AuthContext);
  const [selected, setSelected] = useState<any>({});
  const [createModal, setCreateModal] = useState<boolean>(false);
  const [updateModal, setUpdateModal] = useState<boolean>(false);
  const [uploadModal, setUploadModal] = useState<boolean>(false);
  const [externalModal, setExternalModal] = useState<boolean>(false);

  const [isExporting, setExporting] = useState<boolean>(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [form] = Form.useForm();
  const access = [4, 5, 9];

  const businessId = queryParams.get("id");
  const companyNo = queryParams.get("companyNo");

  const initials = {
    name: "",
  };

  const [filters, setFilters] = useState<any>({ ...initials });

  const params = `businessId=${businessId ? businessId : ""}&name=${
    filters?.name
  }`;

  const [pagination, setPagination] = useState<any>({
    page: 1,
    limit: 10,
    total: 0,
  });

  const {
    data: customers,
    refetch,
    isLoading,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["customers", pagination.page, pagination.limit, params],
    queryFn: () =>
      handleFetchCustomers({
        page: pagination.page,
        limit: pagination.limit,
        params,
      }),
  });

  const handlePageChange = (e: any) => {
    setPagination((prev: any) => ({
      ...prev,
      page: e.current,
      limit: e.pageSize,
    }));
  };
  const handleRefetch = () => {
    refetch();
  };

  const getColumns = (auth: any, access: any) => {
    const columns: any = [
      {
        title: "S/N",
        width: 40,
        align: "center",
        render: (record: any, text: any, index: any) => (
          <span className="text-gray-700 ml-2">
            {pagination?.page * pagination?.limit -
              pagination?.limit +
              index +
              1}
          </span>
        ),
      },
      {
        title: "ACCOUNT",
        width: 80,
        align: "center",
        render: (record: any) => (
          <span className="text-gray-700">
            {formatAccount(record?.account) || "-"}
          </span>
        ),
      },
      {
        title: "CUSTOMER",
        width: 260,
        render: (record: any) => (
          <div className="text-gray-700">
            <div className="truncate">{record?.name || "-"}</div>
          </div>
        ),
      },
      {
        title: "BUSINESS",
        width: 140,
        render: (record: any) => (
          <div className="text-gray-700">
            <div>{record?.business?.name || "-"}</div>
          </div>
        ),
      },
      {
        title: "ANALYSIS",
        width: 80,
        align: "center",
        render: (record: any) => (
          <span className="text-gray-700">{record?.analysis}</span>
        ),
      },
      {
        title: "CATEGORY",
        width: 140,
        align: "center",
        render: (record: any) => (
          <span className="text-gray-700">{record?.category}</span>
        ),
      },
      {
        title: "EXTERNAL",
        width: 80,
        align: "center",
        render: (record: any) => (
          <button
            onClick={() => {
              if (auth?.accessLevel === 9) {
                setSelected(record);
                setExternalModal(true);
              }
            }}
            className="text-gray-700"
          >
            {record?.external}
          </button>
        ),
      },
      {
        title: "PERIOD",
        width: 80,
        align: "center",
        render: (record: any) => (
          <span className="text-gray-700">{record?.periodUsed}</span>
        ),
      },
      {
        title: "O/BALANCE",
        width: 100,
        align: "center",
        render: (record: any) =>
          access.includes(auth?.accessLevel) ? (
            <div className="text-gray-700 text-right">
              {formatShort(record?.balance)}
            </div>
          ) : null,
      },
      {
        title: "O/I",
        width: 40,
        align: "center",
        render: (record: any) =>
          access.includes(auth?.accessLevel) ? (
            <div className="text-gray-700 text-right">{record?.outItems}</div>
          ) : null,
      },
      {
        title: "CREDIT LIMIT",
        width: 100,
        align: "center",
        render: (record: any) =>
          access.includes(auth?.accessLevel) ? (
            <div className="text-gray-700 text-center">
              {formatShort(record?.currCredit)}
            </div>
          ) : null,
      },
      {
        title: "YTD TURNOVER",
        width: 120,
        align: "center",
        render: (record: any) =>
          access.includes(auth?.accessLevel) ? (
            <div className="text-gray-700 text-right">
              {formatShort(record?.ytdTurnover)}
            </div>
          ) : null,
      },
      {
        title: "PREV TURNOVER",
        width: 130,
        align: "center",
        render: (record: any) =>
          access.includes(auth?.accessLevel) ? (
            <div className="text-gray-700 text-right">
              {formatShort(record?.preTurnover)}
            </div>
          ) : (
            <div className="h-6 w-24 bg-gray-200 text-right"></div>
          ),
      },
      {
        title: "ACTIVE",
        width: 60,
        align: "center",
        render: (record: any) => (
          <div className="text-gray-700 text-center">
            {record?.isActive ? (
              <div className="text-green-600 flex items-center">
                <AiOutlineSafetyCertificate size={18} />{" "}
                <span className="mx-1">YES</span>
              </div>
            ) : (
              <div className="text-red-600 flex items-center">
                <LuShieldClose size={18} /> <span className="mx-1">NO</span>
              </div>
            )}
          </div>
        ),
      },
      {
        title: "ACTION",
        width: 100,
        align: "center",
        render: (record: any) => (
          <div className="flex justify-end">
            <button
              onClick={() => {
                setSelected({
                  ...record,
                });
              }}
              className="flex justify-center items-center text-gray-700 border rounded-md p-2 bg-yellow-100 hover:bg-yellow-200 cursor-not-allowed"
            >
              <FiEdit />
            </button>
            <button
              onClick={() => {
                setSelected({
                  ...record,
                });
              }}
              className="flex justify-center items-center ml-1 text-gray-700 border rounded-md p-2 bg-red-100 hover:bg-red-200 cursor-not-allowed"
            >
              <RiDeleteBinLine color="red" />
            </button>
          </div>
        ),
      },
    ];

    return columns.filter((column: any) => {
      if (
        column.title === "O/BALANCE" ||
        column.title === "O/I" ||
        column.title === "CREDIT LIMIT" ||
        column.title === "YTD TURNOVER" ||
        column.title === "PREV TURNOVER"
      ) {
        return access.includes(auth?.accessLevel);
      }
      return true;
    });
  };

  const columns = getColumns(auth, access);

  const clearAllFilters = async () => {
    form.resetFields();
    setFilters({ ...initials });
    handleRefetch();
  };

  const exportData = async () => {
    setExporting(true);
    const users = await handleExportCustomers();
    await ExportToExcel(
      users?.map((item: any) => {
        return {
          ACOUNT: item?.account || "-",
          NAME: item?.name || "-",
          EMAIL: item?.email || "-",
          MOBILE: item?.name || "-",
          "PERIOD USED": item?.periodUsed,
          "PREV CREDIT": item?.prevCredit,
          "CURRENT CREDIT": item?.currCredit,
          "O/I": item?.outItems,
          "O/BALANCE": item?.balance,
          "YTD TURNOVER": item?.ytdTurnover,
          "PREV TURNOVER": item?.preTurnover,
          "NL CONTROL": item?.nlControl,
        };
      }),
      "Customers.xlsx"
    );
    setExporting(false);
  };

  useEffect(() => {
    setPagination({ ...pagination, total: customers?.total });
  }, [customers]);

  return (
    <div className="bg-gray-100">
      <div className="bg-white m-1">
        <div className="flex flex-col sm:flex-row justify-between border-b p-2">
          <div className="">
            <div className="font-bold">Customers</div>
            <div className="text-gray-600">Manage Customer Details</div>
          </div>

          <div className="flex">
            <div className="flex">
              <Form layout="inline" form={form}>
                <Form.Item name="name">
                  <Search
                    placeholder="Search by name"
                    className="rounded-none"
                    allowClear
                    onSearch={(e: any) => {
                      setFilters({ ...filters, name: e });
                    }}
                  />
                </Form.Item>
              </Form>
              <Button
                className="ml-2 focus:outline-none hover:bg-red-100 rounded-none"
                onClick={() => {
                  clearAllFilters();
                }}
              >
                <RiFilterOffLine color="gray" />
              </Button>
            </div>
            <Tooltip title="Export To Excel">
              <button
                className="flex mx-2 justify-center items-center border px-4 h-8  hover:bg-gray-100"
                onClick={() => exportData()}
              >
                {isExporting ? <SlReload /> : <RiFileExcel2Line size={20} />}
              </button>
            </Tooltip>

            <button
              onClick={() => setUploadModal(true)}
              className="flex mx-2 justify-center items-center border px-4 h-8   hover:bg-gray-100"
            >
              <LuUpload /> <span className="mx-2">Upload</span>
            </button>
            <button
              onClick={() => setCreateModal(true)}
              className="flex mx-2 justify-center items-center border px-4 h-8  hover:bg-gray-100"
            >
              <LuPlus size={18} /> <span className="mx-2">New</span>
            </button>
          </div>
        </div>
        {isError ? (
          <Something refetch={refetch} isFetching={isFetching} />
        ) : (
          <div className="">
            <div className="py-1 flex">
              <AllBusinesses businessId={businessId || ""} />
            </div>

            <div className="">
              <CreditMetrics
                businessId={businessId || ""}
                companyNo={companyNo || ""}
              />
            </div>

            <Table
              size="small"
              dataSource={customers?.records}
              columns={columns}
              scroll={{ y: 660, x: 0 }}
              rowKey="id"
              style={{ fontSize: "12px" }}
              bordered
              pagination={{
                current: pagination?.page,
                pageSize: pagination?.limit,
                total: pagination?.total,
              }}
              onChange={(e: any) => handlePageChange(e)}
              loading={isLoading}
            />
          </div>
        )}
      </div>

      <CreateUser
        isVisible={createModal}
        setVisible={setCreateModal}
        refetch={handleRefetch}
      />

      <UpdateUser
        isVisible={updateModal}
        setVisible={setUpdateModal}
        refetch={refetch}
        selected={selected}
      />

      <UploadCustomers
        isVisible={uploadModal}
        setVisible={setUploadModal}
        selected={selected}
        refetch={refetch}
      />

      <UpdateExternal
        isVisible={externalModal}
        setVisible={setExternalModal}
        selected={selected}
        refetch={refetch}
      />
    </div>
  );
}
